import { ContractVersion } from '~/typings/context';

const contractWeights = {
  disclosure: 1,
  direct: 2,
  vnm: 3,
  agency: 4,
};

export const sortContracts = (contracts: ContractVersion[]): ContractVersion[] => {
  return [...contracts].sort((a, b) => {
    // Sort by contract type first, then by display name
    // If the contract type is not in the contractWeights object, it will be sorted to the end
    const weightA = contractWeights[a.contractType] || Number.MAX_SAFE_INTEGER;
    const weightB = contractWeights[b.contractType] || Number.MAX_SAFE_INTEGER;

    if (weightA !== weightB) {
      return weightA - weightB;
    }

    return a.displayName.localeCompare(b.displayName);
  });
};
